<modal-search-filter-item [title]="model.label" (save)="Save($event)" (close)="Close($event)" [processing]="processing" [modalMode]="modalMode">
  <div class="form-group">
    <input *ngIf="model.searchable" type="text" #txt id="txt" name="txt" class="mb-4 font-reg form-control form-control-lg" [placeholder]="model.placeholder" [(ngModel)]="searchTerm" (keypress)="keyPress($event)">
    <div *ngIf="model.helpText">
      <p class="font-md font-weight-bold border-bottom pb-3">{{model.helpText}}</p>
    </div>
    <div class="row-x grid-container">
      <ng-container *ngIf="FilteredItemsCount==0">
        <strong class="col-md-12-x">No options to display</strong>
      </ng-container>
      <ng-container #itemsContainer></ng-container>
    </div>
  </div>
</modal-search-filter-item>

<ng-template #item let-item="item" let-i="i" let-lastGroup="lastGroup">
  <h3 class="col-md-12-x group-heading mb-2" *ngIf="filterItem(item) && item.group && item.group != lastGroup">{{item.group}}</h3>
  <div class="col-md-6-x grid-item" *ngIf="filterItem(item)">
    <div class="checkbox-wrapper">
      <input [id]="'item'+i" type="checkbox" name="values[]" [checked]="selected[i]" (change)="selected[i] = $event.target.checked" (keyup.enter)="Save($event)">
      <label [for]="'item'+i" class="d-flex align-items-center">
        <span (change)="selected[i] = $event.target.checked" (keyup.enter)="Save($event)"></span>
        {{item.label}}
      </label>
    </div>
  </div>
</ng-template>
